import { Component, OnInit } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RuleGroupMappingFunctionality } from './../rule-group-functionality.model';
import { RuleGroup } from './../rule-group.model';
import { RuleManagementService } from 'app/admin/rules/rule-management.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { MessageService } from 'app/services/messages.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';
import { ApplicationValue } from 'app/services/warmup/application-type.model';
import { ApplicationTypeConstants, WarmUpService } from 'app/services/warmup/warmup.service';

import { Observable } from 'rxjs/Observable';

@Component({
    selector: 'add-rulegroupmapping',
    templateUrl: './add-rulegroupmapping.component.html',
    styleUrls: ['./add-rulegroupmapping.component.css']
})
/**
 * Component to add a new rule group mapping.
 *
 * @author pankaj.khurana@vernuso.com (Pankaj Khurana)
 */
export class AddRuleGroupMappingComponent implements OnInit {

    selectedRuleGroupMapping: RuleGroupMappingFunctionality;
    action: string;
    ruleGroupMappingForm: FormGroup;
    mappingId: number;
    arrApplicationFunctionality: ApplicationValue[];
    arrRuleGroup: RuleGroup[];
    savingRuleGroupFunctionality = false;

    formErrors = {
        'applicationfunctionality': '',
        'rulegroup': '',
    };

    validationMessages = {
        'applicationfunctionality': {
            'required': 'Required field value.',
        },
        'rulegroup': {
            'required': 'Required field value.',
        },

    };

    constructor(
        public dialogRef: MdDialogRef<any>,
        private fb: FormBuilder,
        private ruleManagementService: RuleManagementService,
        private warmUpService: WarmUpService,
        private snackBarService: SnackBarService,
        private trackingService: TrackingService
    ) { }

    ngOnInit() {
        this.createForm();
        this.setUpApplicationFunctionality();
        this.setUpRuleGroup();
        this.updateRuleGroupMappingForm();
    }

    setUpApplicationFunctionality() {
        const arrApplicationFunctionality =
            this.warmUpService.getApplicationValue(ApplicationTypeConstants.APPLICATION_FUNCTIONALITY);
        if (arrApplicationFunctionality instanceof Observable) {
            arrApplicationFunctionality.subscribe(
                response => {
                    this.warmUpService.setApplicationTypeInLS(response);
                    this.arrApplicationFunctionality = response.values;
                }
            );
        } else {
            this.arrApplicationFunctionality = arrApplicationFunctionality;
        }
    }

    setUpRuleGroup() {
        this.ruleManagementService.getRuleGroup()
            .subscribe(response => {
                this.arrRuleGroup = response;
            });
    }

    createForm() {
        this.ruleGroupMappingForm = this.fb.group({
            applicationfunctionality: ['', Validators.required],
            rulegroup: ['', Validators.required],

        });
        this.ruleGroupMappingForm.valueChanges.subscribe(data => this.onValueChanged(data));
        this.onValueChanged();
    }

    onValueChanged(data?: any) {
        if (!this.ruleGroupMappingForm) {
            return;
        }
        const form = this.ruleGroupMappingForm;
        for (const field in this.formErrors) {
            // clear previous error message (if any)
            this.formErrors[field] = '';
            const control = form.get(field);
            if (control && control.touched && !control.valid) {
                const messages = this.validationMessages[field];
                for (const key in control.errors) {
                    this.formErrors[field] += messages[key] + ' ';
                }
            }
        }
    }

    onSubmit({ value, valid }): void {
        const rulegroupmappingfunctionality = new RuleGroupMappingFunctionality();
        rulegroupmappingfunctionality.id = this.mappingId;
        rulegroupmappingfunctionality.functionalityId = value.applicationfunctionality;
        rulegroupmappingfunctionality.ruleGroupId = value.rulegroup;

        this.ruleManagementService.addRuleGroupMappingFunctionality(rulegroupmappingfunctionality)
            .subscribe(
            success => {
                this.savingRuleGroupFunctionality = false;
                if (success.flagResult) {
                    this.dialogRef.close(success.arrResult);
                }
                this.trackingService
                    .emitEvent(
                    TrackingConstants.RULE_MANAGEMENT,
                    TrackingConstants.SAVE_RULE_GROUP_FUNCTIONALITY,
                    TrackingConstants.SUCCESS, 1);
                this.callSnackBarService(success, this.action);
            },
            err => {
                this.savingRuleGroupFunctionality = false;
                this.trackingService
                    .emitEvent(
                    TrackingConstants.RULE_MANAGEMENT,
                    TrackingConstants.SAVE_RULE_GROUP_FUNCTIONALITY,
                    TrackingConstants.FAILURE, 0);
                this.callSnackBarService(err, this.action);
            }
            );
    }

    callSnackBarService(response: any, operation: string) {
        this.snackBarService
            .showStatus(response,
            operation === 'Add'
            && MessageService.ADD_RULE_GROUP_FUNCTIONALITY_SUCCESS || MessageService.UPDATE_RULE_GROUP_FUNCTIONALITY_SUCCESS,
            MessageService.ADD_RULE_GROUP_FUNCTIONALITY_FAILURE);
    }

    closeDialog(formResponse: Object): void {
        this.ruleGroupMappingForm.reset();
        this.dialogRef.close(formResponse);
    }
    
    updateRuleGroupMappingForm(): void {
        if (this.selectedRuleGroupMapping) {
            this.mappingId = this.selectedRuleGroupMapping.id;
            this.ruleGroupMappingForm.patchValue({
                applicationfunctionality: this.selectedRuleGroupMapping.functionalityId,
                rulegroup: this.selectedRuleGroupMapping.ruleGroupId,
            });
        }
    }
}




// WEBPACK FOOTER //
// ./src/app/admin/rules/addrulegroupmapping/add-rulegroupmapping.component.ts